import { useEffect, useState } from "react";
import useAirlineAdminApi from "../../../../services/api/useAirlineAdminApi";
import AviationStackTable from "../Tables/AviationStackTable";
import { PAGINATION_PAGE_SIZE } from "../../../../utils/constants";
import { useQuery } from "@tanstack/react-query";
import { CaretLeftOutlined, CaretRightOutlined } from "@ant-design/icons";
import dataSourceIcon from "../../../../assets/images/data-source-icon.svg";
import ROUTE_PATHS from "../../../../utils/routePaths";
import { Link } from "react-router-dom";
import CommercialAirlineNavigationBar from "../../../../components/element/CommercialAirlineNavigationBar";

const AviationStackFailure = () => {
  const [currentPage, setCurrentPage] = useState(() => {
    return sessionStorage.getItem("aviationStackFailureCurrentPage")
      ? Number(sessionStorage.getItem("aviationStackFailureCurrentPage"))
      : 0;
  });
  const pageSize = PAGINATION_PAGE_SIZE;
  const { getAviationStackFailure } = useAirlineAdminApi();

  const {
    data: aviationStackFailureData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["get-aviation-stack-failure", currentPage, pageSize],
    queryFn: () => {
      return getAviationStackFailure(currentPage, pageSize);
    },
  });

  useEffect(() => {
    sessionStorage.setItem("aviationStackFailureCurrentPage", currentPage);
  }, [currentPage]);

  const handlePreviousPage = () => {
    setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  return (
    <div className="aviation-stack-failure-container">
      <CommercialAirlineNavigationBar
        title={"Flight Data Failure"}
        navigationLogo={dataSourceIcon}
        fullWidthContent={true}
        backContent={
          <div className="navigation-header">
            <Link
              to={ROUTE_PATHS.COMMERCIAL_AIRLINE_HOME}
              className="navigation-header-link"
            >
              Home/
            </Link>
            <Link
              to={ROUTE_PATHS.COMMERCIAL_AIRLINE_DATA_SOURCE}
              className="navigation-header-link"
            >
              Data Source/
            </Link>
            Flight Data Failure
          </div>
        }
      />
      <AviationStackTable
        aviationStackData={aviationStackFailureData}
        isLoading={isLoading}
        error={error}
        isSuccess={false}
        className="aviation-stack-failure-table-margin"
      />
      {aviationStackFailureData?.data?.content &&
        aviationStackFailureData?.data?.content.length > 0 && (
          <div className="pagination-container">
            <div className="pagination-content">
              Page {currentPage + 1} of{" "}
              {aviationStackFailureData?.data?.totalPages}
            </div>
            <button
              className="pagination-button"
              onClick={handlePreviousPage}
              disabled={currentPage === 0}
            >
              <CaretLeftOutlined />
            </button>
            <button
              className="pagination-button"
              onClick={handleNextPage}
              disabled={
                currentPage + 1 === aviationStackFailureData?.data?.totalPages
              }
            >
              <CaretRightOutlined />
            </button>
          </div>
        )}
    </div>
  );
};

export default AviationStackFailure;
